export default __webpack_public_path__ + "static/media/WEG5.d5f29828.jpg";